<template>
  <!-- SHOW STRINGS ARRAY -->
  <ul class="custom_select__list" v-if="isString">
    <li
      :class="{
        custom_select__item: true,
        selected: selectedAsAnArray.includes(option),
      }"
      v-for="option in options"
      :key="option"
      @click="selectOption(option)"
    >
      {{ option }}
    </li>
  </ul>

  <!-- SHOW OBJECTS ARRAY -->
  <ul class="custom_select__list" v-else>
    <li
      :class="{
        custom_select__item: true,
        selected: selectedAsAnArray.includes(option.value),
      }"
      v-for="option in options"
      :key="option.value"
      @click="selectOption(option.value)"
    >
      {{ option.label || option.value }}
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    modelValue: [String, Array],
    options: {
      type: Array,
      default: () => ["Empty"],
    },
    multiple: Boolean,
  },
  computed: {
    selectedAsAnArray() {
      if (typeof this.modelValue === "string") return [this.modelValue];
      return this.modelValue || [];
    },
    selectedAsAnObject() {
      let object = {};
      if (this.selectedAsAnArray.length === 0) return object;
      this.selectedAsAnArray.forEach((item) => {
        object[item] = item;
      });
      return object;
    },
    selected: {
      get() {
        return this.selectedAsAnObject;
      },
      set(newValue) {
        this.$emit("update:modelValue", Object.keys(newValue));
        this.$emit("onchange", Object.keys(newValue));
      },
    },
    isString() {
      return typeof this.options[0] == "string" ? true : false;
    },
  },
  methods: {
    selectOption(option) {
      if (option in this.selected) {
        const options = { ...this.selected };
        delete options[option];
        this.selected = options;
      } else {
        if (this.multiple === false) {
          this.selected = { [option]: option };
        } else {
          this.selected = {
            [option]: option,
            ...this.selected,
          };
        }
      }
    },
  },
};
</script>

<style scoped>
.custom_select__list {
  flex: 1;
  display: flex;
  flex-direction: column;
  list-style: none;
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.65);
  line-height: 30px;
  background: #fff;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
.custom_select__item {
  cursor: pointer;
}
.custom_select__item:hover {
  color: #1890ff;
}
.custom_select__item.selected {
  background-color: #1890ff;
  color: #fff;
}
</style>
